import React from "react";

export type StatColor = "blue" | "navy" | "orange" | "teal" | "red" | "green";

const COLOR_MAP: Record<StatColor, { bg: string; fg: string }> = {
  blue: { bg: "var(--blue-tint)", fg: "var(--blue)" },
  navy: { bg: "var(--surface-3)", fg: "var(--navy)" },
  orange: { bg: "var(--orange-tint)", fg: "var(--orange)" },
  teal: { bg: "var(--teal-tint)", fg: "var(--teal)" },
  red: { bg: "var(--red-tint)", fg: "var(--red)" },
  green: { bg: "var(--green-tint)", fg: "var(--green)" },
};

interface StatTileProps {
  label: string;
  value: React.ReactNode;
  icon: React.ReactNode;
  color?: StatColor;
  foot?: React.ReactNode;
  footDirection?: "up" | "down" | "neutral";
}

const StatTile: React.FC<StatTileProps> = ({
  label,
  value,
  icon,
  color = "blue",
  foot,
  footDirection = "neutral",
}) => {
  const c = COLOR_MAP[color];
  return (
    <div className="ds-stat-tile">
      <div className="ds-stat-tile-top">
        <span className="ds-stat-tile-label">{label}</span>
        <span className="ds-stat-icon" style={{ background: c.bg, color: c.fg }}>
          {icon}
        </span>
      </div>
      <div className="ds-stat-tile-value">{value}</div>
      {foot && (
        <div className={`ds-stat-tile-foot ${footDirection !== "neutral" ? footDirection : ""}`}>
          {foot}
        </div>
      )}
    </div>
  );
};

export default StatTile;
